module.exports = __webpack_public_path__ + "static/question-mark.76b31dbeb86360fca34870b3b1a1eae3.svg";